export default __webpack_public_path__ + "assets/icon-credit-note-black.ae27f4f8.webp";